import type {FC, SVGProps} from "react"

type IconProps = SVGProps<SVGSVGElement>

export const ChevronLeftIcon: FC<IconProps> = (props) => (
  <svg
    width="8"
    height="12"
    viewBox="0 0 8 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_21_2)">
      <path
        d="M1.16 0.00599957C1.11874 0.00562334 1.07785 0.0138807 1.03996 0.030241C1.00207 0.0466014 0.968025 0.0707035 0.940003 0.101C0.882303 0.1613 0.850098 0.24154 0.850098 0.325C0.850098 0.408459 0.882303 0.488699 0.940003 0.549L6.39 6L0.940003 11.457C0.882303 11.5173 0.850098 11.5975 0.850098 11.681C0.850098 11.7645 0.882303 11.8447 0.940003 11.905C1.06 12.032 1.261 12.032 1.388 11.905L7.059 6.221C7.1167 6.1607 7.14891 6.08046 7.14891 5.997C7.14891 5.91354 7.1167 5.8333 7.059 5.773L1.381 0.0950003C1.32293 0.0357677 1.24394 0.00166108 1.161 0V0.00599957H1.16Z"
        fill="white"
        fill-opacity="0.7"
      />
    </g>
    <defs>
      <clipPath id="clip0_21_2">
        <rect width="8" height="12.0003" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const CloseIcon: FC<IconProps> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.59825 7.99681L15.8743 0.71681C15.9142 0.678034 15.946 0.631635 15.9676 0.580361C15.9893 0.529087 16.0005 0.473982 16.0005 0.41831C16.0005 0.362639 15.9893 0.307533 15.9676 0.256259C15.946 0.204985 15.9142 0.158586 15.8743 0.11981C15.7937 0.0429088 15.6866 0 15.5753 0C15.4639 0 15.3568 0.0429088 15.2763 0.11981L7.99225 7.39981L0.716252 0.12781C0.678232 0.0878107 0.632475 0.0559607 0.581761 0.0341969C0.531048 0.0124331 0.476438 0.00121021 0.421252 0.00121021C0.366066 0.00121021 0.311457 0.0124331 0.260744 0.0341969C0.210031 0.0559607 0.164273 0.0878107 0.126253 0.12781C-0.0337469 0.29681 -0.0417469 0.557811 0.126253 0.717811L7.41025 7.99681L0.126253 15.2768C0.0863061 15.3156 0.0545483 15.362 0.0328617 15.4133C0.0111751 15.4645 0 15.5196 0 15.5753C0 15.631 0.0111751 15.6861 0.0328617 15.7374C0.0545483 15.7886 0.0863061 15.835 0.126253 15.8738C0.164421 15.9136 0.210226 15.9452 0.26092 15.9668C0.311613 15.9884 0.366148 15.9995 0.421252 15.9995C0.476356 15.9995 0.530892 15.9884 0.581586 15.9668C0.632279 15.9452 0.678084 15.9136 0.716252 15.8738L8.00025 8.59381L15.2843 15.8738C15.3224 15.9136 15.3682 15.9452 15.4189 15.9668C15.4696 15.9884 15.5241 15.9995 15.5793 15.9995C15.6344 15.9995 15.6889 15.9884 15.7396 15.9668C15.7903 15.9452 15.8361 15.9136 15.8743 15.8738C15.9514 15.7934 15.9944 15.6862 15.9944 15.5748C15.9944 15.4634 15.9514 15.3562 15.8743 15.2758L8.59025 7.99581L8.59825 7.99681Z"
      fill={props.fill || "#FFFFFF"}
    />
  </svg>
)

export const FullScreenModeIcon: FC<IconProps> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_15_41"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="16"
    >
      <path d="M0 0H16V16H0V0Z" fill="white" />
    </mask>
    <g mask="url(#mask0_15_41)">
      <path
        d="M6.284 5.717L1.368 0.8H4.402C4.50809 0.8 4.60983 0.757857 4.68484 0.682842C4.75986 0.607828 4.802 0.506086 4.802 0.4C4.802 0.293913 4.75986 0.192172 4.68484 0.117157C4.60983 0.0421424 4.50809 0 4.402 0H0.402C0.295914 0 0.194171 0.0421424 0.119157 0.117157C0.0441423 0.192172 0.00199986 0.293913 0.00199986 0.4V4.4C0.00199986 4.50609 0.0441423 4.60783 0.119157 4.68284C0.194171 4.75786 0.295914 4.8 0.402 4.8C0.508087 4.8 0.609829 4.75786 0.684843 4.68284C0.759858 4.60783 0.802 4.50609 0.802 4.4V1.366L5.719 6.282C5.75601 6.31943 5.80009 6.34915 5.84866 6.36943C5.89724 6.38971 5.94936 6.40015 6.002 6.40015C6.05464 6.40015 6.10676 6.38971 6.15534 6.36943C6.20391 6.34915 6.24799 6.31943 6.285 6.282C6.3598 6.20701 6.40182 6.10542 6.40182 5.9995C6.40182 5.89358 6.35881 5.79199 6.284 5.717ZM15.601 0H11.601C11.4949 0 11.3932 0.0421424 11.3182 0.117157C11.2431 0.192172 11.201 0.293913 11.201 0.4C11.201 0.506086 11.2431 0.607828 11.3182 0.682842C11.3932 0.757857 11.4949 0.8 11.601 0.8H14.635L9.719 5.717C9.65188 5.79328 9.61632 5.89225 9.61951 5.99381C9.62271 6.09537 9.66444 6.1919 9.73622 6.26381C9.80801 6.33572 9.90447 6.37762 10.006 6.38099C10.1076 6.38437 10.2066 6.34898 10.283 6.282L15.201 1.366V4.4C15.201 4.50609 15.2431 4.60783 15.3182 4.68284C15.3932 4.75786 15.4949 4.8 15.601 4.8C15.7071 4.8 15.8088 4.75786 15.8838 4.68284C15.9589 4.60783 16.001 4.50609 16.001 4.4V0.4C16.001 0.293913 15.9589 0.192172 15.8838 0.117157C15.8088 0.0421424 15.7071 0 15.601 0ZM6.282 9.718C6.20701 9.6432 6.10542 9.60118 5.9995 9.60118C5.89358 9.60118 5.79199 9.6432 5.717 9.718L0.8 14.634V11.6C0.8 11.4939 0.757857 11.3922 0.682842 11.3172C0.607828 11.2421 0.506086 11.2 0.4 11.2C0.293913 11.2 0.192172 11.2421 0.117157 11.3172C0.0421424 11.3922 0 11.4939 0 11.6V15.6C0 15.82 0.18 16 0.4 16H4.4C4.50609 16 4.60783 15.9579 4.68284 15.8828C4.75786 15.8078 4.8 15.7061 4.8 15.6C4.8 15.4939 4.75786 15.3922 4.68284 15.3172C4.60783 15.2421 4.50609 15.2 4.4 15.2H1.366L6.282 10.282C6.3568 10.207 6.39882 10.1054 6.39882 9.9995C6.39882 9.89358 6.3568 9.79199 6.282 9.717V9.718ZM15.6 11.2C15.4939 11.2 15.3922 11.2421 15.3172 11.3172C15.2421 11.3922 15.2 11.4939 15.2 11.6V14.635L10.282 9.718C10.2059 9.64906 10.1062 9.61201 10.0036 9.61454C9.90093 9.61707 9.80318 9.65897 9.73058 9.73158C9.65797 9.80418 9.61607 9.90193 9.61354 10.0046C9.61101 10.1072 9.64806 10.2069 9.717 10.283L14.634 15.2H11.6C11.4939 15.2 11.3922 15.2421 11.3172 15.3172C11.2421 15.3922 11.2 15.4939 11.2 15.6C11.2 15.7061 11.2421 15.8078 11.3172 15.8828C11.3922 15.9579 11.4939 16 11.6 16H15.6C15.7061 16 15.8078 15.9579 15.8828 15.8828C15.9579 15.8078 16 15.7061 16 15.6V11.6C16 11.4939 15.9579 11.3922 15.8828 11.3172C15.8078 11.2421 15.7061 11.2 15.6 11.2Z"
        fill="white"
      />
    </g>
  </svg>
)

export const CloseFullScreenModeIcon: FC<IconProps> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_22_11"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="16"
    >
      <path d="M0 0H16V16H0V0Z" fill="white" />
    </mask>
    <g mask="url(#mask0_22_11)">
      <path
        d="M6.00001 2.4C5.89392 2.4 5.79218 2.44214 5.71716 2.51716C5.64215 2.59217 5.60001 2.69391 5.60001 2.8V5.035L0.684007 0.118C0.608446 0.0460834 0.50778 0.00652907 0.403473 0.00777149C0.299166 0.00901391 0.199471 0.0509549 0.125645 0.124651C0.0518185 0.198347 0.0097022 0.297968 0.00827533 0.402272C0.00684846 0.506577 0.0462241 0.607312 0.118007 0.683L5.03501 5.6H2.80001C2.69392 5.6 2.59218 5.64214 2.51716 5.71716C2.44215 5.79217 2.40001 5.89391 2.40001 6C2.40001 6.10609 2.44215 6.20783 2.51716 6.28284C2.59218 6.35786 2.69392 6.4 2.80001 6.4H6.00001C6.10609 6.4 6.20784 6.35786 6.28285 6.28284C6.35786 6.20783 6.40001 6.10609 6.40001 6V2.8C6.40001 2.69391 6.35786 2.59217 6.28285 2.51716C6.20784 2.44214 6.10609 2.4 6.00001 2.4ZM15.883 0.117C15.8459 0.079809 15.8017 0.0503059 15.7532 0.0301762C15.7046 0.0100464 15.6526 -0.000314713 15.6 -0.000314713C15.5474 -0.000314713 15.4954 0.0100464 15.4468 0.0301762C15.3983 0.0503059 15.3542 0.079809 15.317 0.117L10.4 5.034V2.799C10.4 2.69291 10.3579 2.59117 10.2828 2.51616C10.2078 2.44114 10.1061 2.399 10 2.399C9.89392 2.399 9.79218 2.44114 9.71716 2.51616C9.64215 2.59117 9.60001 2.69291 9.60001 2.799V6C9.60001 6.221 9.78001 6.4 10 6.4H13.2C13.3061 6.4 13.4078 6.35786 13.4829 6.28284C13.5579 6.20783 13.6 6.10609 13.6 6C13.6 5.89391 13.5579 5.79217 13.4829 5.71716C13.4078 5.64214 13.3061 5.6 13.2 5.6H10.966L15.882 0.683C15.9568 0.608013 15.9988 0.506419 15.9988 0.4005C15.9988 0.294582 15.9568 0.192987 15.882 0.118L15.883 0.117ZM6.00001 9.6H2.80001C2.69392 9.6 2.59218 9.64214 2.51716 9.71716C2.44215 9.79217 2.40001 9.89391 2.40001 10C2.40001 10.1061 2.44215 10.2078 2.51716 10.2828C2.59218 10.3579 2.69392 10.4 2.80001 10.4H5.03501L0.118007 15.318C0.0779188 15.3545 0.0456549 15.3987 0.0231736 15.448C0.00069236 15.4973 -0.0115372 15.5506 -0.0127742 15.6048C-0.0140111 15.659 -0.00422932 15.7128 0.0159782 15.7631C0.0361856 15.8134 0.0663971 15.859 0.10478 15.8973C0.143162 15.9355 0.188916 15.9656 0.239263 15.9856C0.28961 16.0056 0.343502 16.0152 0.397668 16.0138C0.451835 16.0124 0.505146 15.9999 0.554367 15.9773C0.603589 15.9546 0.647694 15.9222 0.684007 15.882L5.60101 10.966V13.2C5.60101 13.3061 5.64315 13.4078 5.71816 13.4828C5.79318 13.5579 5.89492 13.6 6.00101 13.6C6.10709 13.6 6.20883 13.5579 6.28385 13.4828C6.35886 13.4078 6.40101 13.3061 6.40101 13.2V10C6.40101 9.89391 6.35886 9.79217 6.28385 9.71716C6.20883 9.64214 6.10609 9.6 6.00001 9.6ZM15.883 15.318L10.965 10.4H13.2C13.3061 10.4 13.4078 10.3579 13.4829 10.2828C13.5579 10.2078 13.6 10.1061 13.6 10C13.6 9.89391 13.5579 9.79217 13.4829 9.71716C13.4078 9.64214 13.3061 9.6 13.2 9.6H10C9.89392 9.6 9.79218 9.64214 9.71716 9.71716C9.64215 9.79217 9.60001 9.89391 9.60001 10V13.2C9.60001 13.3061 9.64215 13.4078 9.71716 13.4828C9.79218 13.5579 9.89392 13.6 10 13.6C10.1061 13.6 10.2078 13.5579 10.2828 13.4828C10.3579 13.4078 10.4 13.3061 10.4 13.2V10.966L15.318 15.883C15.355 15.9201 15.3989 15.9496 15.4473 15.9697C15.4957 15.9898 15.5476 16.0001 15.6 16.0001C15.6524 16.0001 15.7043 15.9898 15.7527 15.9697C15.8011 15.9496 15.845 15.9201 15.882 15.883C15.9568 15.808 15.9988 15.7064 15.9988 15.6005C15.9988 15.4946 15.9578 15.393 15.883 15.318Z"
        fill="white"
      />
    </g>
  </svg>
)

export const PresentationModeIcon: FC<IconProps> = (props) => (
  <svg
    width="18"
    height="16"
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_15_42)">
      <path
        d="M17.587 0.86H0.414C0.303002 0.855126 0.198126 0.807773 0.121067 0.727736C0.0440078 0.647698 0.000662847 0.541102 0 0.43C0 0.2 0.193 0 0.414 0H17.586C17.807 0 18 0.2 18 0.43C18.001 0.659 17.807 0.86 17.587 0.86ZM13.198 16C13.1232 15.9964 13.0506 15.9732 12.9874 15.9329C12.9243 15.8925 12.8728 15.8364 12.838 15.77L10.078 10.523C10.0271 10.4242 10.016 10.3097 10.0469 10.203C10.0777 10.0963 10.1483 10.0054 10.244 9.949C10.437 9.835 10.686 9.92 10.796 10.122L13.556 15.37C13.666 15.57 13.585 15.829 13.391 15.943C13.3313 15.9751 13.2656 15.9946 13.198 16ZM4.805 16C4.73751 15.9941 4.67189 15.9747 4.612 15.943C4.51644 15.8865 4.44606 15.7956 4.41521 15.6889C4.38437 15.5822 4.39538 15.4678 4.446 15.369L7.206 10.122C7.316 9.921 7.566 9.835 7.759 9.949C7.8543 10.0055 7.92451 10.0962 7.95534 10.2027C7.98617 10.3091 7.97532 10.4233 7.925 10.522L5.164 15.77C5.108 15.915 4.97 16 4.804 16H4.805Z"
        fill="white"
      />
      <path
        d="M11.818 13.506H6.18699C6.07582 13.5014 5.97069 13.4541 5.89342 13.3741C5.81615 13.294 5.77266 13.1873 5.77199 13.076C5.77199 12.846 5.96599 12.646 6.18699 12.646H11.818C12.039 12.646 12.232 12.846 12.232 13.076C12.232 13.305 12.039 13.506 11.818 13.506ZM15.46 10.753H2.54199C2.43099 10.7481 2.32612 10.7008 2.24906 10.6207C2.172 10.5407 2.12865 10.4341 2.12799 10.323V0.43C2.12799 0.2 2.32099 0 2.54199 0H15.462C15.684 0 15.877 0.2 15.877 0.43V10.323C15.876 10.552 15.683 10.753 15.462 10.753H15.46ZM2.95499 9.893H15.048L15.047 0.86H2.95499V9.893Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_15_42">
        <rect width="18" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const DownloadIcon: FC<IconProps> = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#n8mdv09fpa)" fill="#fff">
      <path d="M14.068 8.195a.486.486 0 0 0-.672 0l-3.932 3.931V1.421A.47.47 0 0 0 8.99.947a.47.47 0 0 0-.473.474v10.696L4.585 8.185a.486.486 0 0 0-.673 0 .486.486 0 0 0 0 .673l4.737 4.737a.46.46 0 0 0 .663 0l4.737-4.737a.486.486 0 0 0 0-.673l.02.01z" />
      <path d="M16.579 17.053H1.42A1.42 1.42 0 0 1 0 15.633v-1.896a.47.47 0 0 1 .474-.473.47.47 0 0 1 .473.473v1.895a.47.47 0 0 0 .474.474H16.58a.47.47 0 0 0 .474-.474v-1.895a.47.47 0 0 1 .473-.473.47.47 0 0 1 .474.473v1.895a1.42 1.42 0 0 1-1.421 1.421z" />
    </g>
    <defs>
      <clipPath id="n8mdv09fpa">
        <path fill="#fff" d="M0 0h18v18H0z" />
      </clipPath>
    </defs>
  </svg>
)

export const DottedSpinnerIcon: FC<IconProps> = (props) => (
  <svg
    width="46"
    height="46"
    viewBox="0 0 46 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="23" cy="43.5" r="2.5" fill="#595958" />
    <circle cx="23" cy="2.5" r="2.5" fill="#595958" />
    <circle cx="33.25" cy="41" r="2.5" fill="#595958" />
    <circle cx="33.25" cy="5.25" r="2.5" fill="#595958" />
    <circle cx="12.5" cy="41" r="2.5" fill="#595958" />
    <circle cx="5" cy="33" r="2.5" fill="#595958" />
    <circle cx="2.5" cy="23" r="2.5" fill="#595958" />
    <circle cx="43.5" cy="23" r="2.5" fill="#595958" />
    <circle cx="5" cy="12.5" r="2.5" fill="#595958" />
    <circle cx="40.75" cy="12.5" r="2.5" fill="#595958" />
    <circle cx="12.75" cy="5" r="2.5" fill="#595958" />
    <circle cx="12.75" cy="5" r="2.5" fill="#595958" />
  </svg>
)
